import { faStopwatch } from "@fortawesome/pro-solid-svg-icons";
import { Chip } from "@mui/material";

import { Tooltip } from "@/components/ui-v2";
import { Icon } from "@/components/ui-v2/Icon/Icon";
import { useBaseModelMetadata } from "@/hooks";
import { StyleCapabilities } from "@/types";

import { ModelCardFragment } from "../../models.graphql";

interface ModelDurationIndicatorProps {
  model: ModelCardFragment;
}

export const ModelDurationIndicator = (props: ModelDurationIndicatorProps) => {
  const { model } = props;
  const { getTimingRange } = useBaseModelMetadata();
  const inferenceTimingRange = getTimingRange(
    (model.capabilities as StyleCapabilities | null)?.baseModelId,
  );

  if (!inferenceTimingRange) return null;

  return (
    <Tooltip
      title={`Inferences with this model typically take ${inferenceTimingRange} to complete. This may vary based on server load and input complexity.`}
    >
      <Chip
        label={
          <>
            <Icon icon={faStopwatch} data-testid="duration-icon" />
            {" " + inferenceTimingRange}
          </>
        }
        variant="filled"
        size="small"
        sx={{
          color: "secondary.800",
        }}
      />
    </Tooltip>
  );
};
